// A display-only price suffix must not invalidate an existing customer assignment.
// The actual amount always comes from sku_price, never from this suffix.
export function retailPriceListIdentity(value) {
  const name = String(value && typeof value === "object" ? (value.policyKey || value.policy_key || value.name || "") : (value || "")).trim().toLowerCase();
  return name.replace(/\s*\|\s*\$?\d+(?:\.\d{1,2})?$/, "").trim();
}

/** @template {{name: string}} T @param {T[]} rows @param {unknown} requested @returns {T | undefined} */
export function findRetailPriceList(rows, requested) {
  const name = String(requested || "").trim().toLowerCase();
  const byId = rows.find(row => row.id && String(row.id).toLowerCase() === name);
  if (byId) return byId;
  const exact = rows.find(row => row.name.trim().toLowerCase() === name);
  if (exact) return exact;
  const identity = retailPriceListIdentity(name);
  if (!identity) return undefined;
  const matches = rows.filter(row => retailPriceListIdentity(row.name) === identity || (row.aliases || []).some(alias => retailPriceListIdentity(alias) === identity));
  if (matches.length > 1) throw new RangeError(`More than one ${identity} price list matches. Choose its full saved name.`);
  return matches[0];
}
